export function getElementMaximumScrollPosition(element) {
    return {
        x: Math.max(0, element.scrollWidth - element.clientWidth),
        y: Math.max(0, element.scrollHeight - element.clientHeight)
    };
}
//# sourceMappingURL=get-element-maximum-scroll-position.js.map